import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import superagent from 'superagent';
import RESOURCE_NAMES from './resources';
import EnvUtils from '../utils/EnvUtils';
var acceptLanguage = 'Accept-Language';

/**
 * Utility class exposing functions available against REST APIs.
 */
var RESTService = /*#__PURE__*/function () {
  function RESTService() {
    _classCallCheck(this, RESTService);
  }
  _createClass(RESTService, null, [{
    key: "getRestResponseTimeout",
    value:
    /**
     * Callback type functions within the RESTService class.
     *
     * @callback requestCallback
     * @param {boolean} success Indicates whether a request has been fulfilled or rejected.
     * @param {Object} response For a successful request, the response body will be returned. For
     * an unsuccessful request, an error object will be returned.
     * @param {Object} header If SSO is enabled the response header will also be returned.
     *
     */
    function getRestResponseTimeout() {
      return process.env.REACT_APP_RESPONSE_TIMEOUT ? process.env.REACT_APP_RESPONSE_TIMEOUT * 1000 : 10000;
    }
  }, {
    key: "getRestDeadlineTimeout",
    value: function getRestDeadlineTimeout() {
      return process.env.REACT_APP_RESPONSE_DEADLINE ? process.env.REACT_APP_RESPONSE_DEADLINE * 1000 : 60000;
    }
  }, {
    key: "isSPSSOEnabled",
    value: function isSPSSOEnabled() {
      return process.env.REACT_APP_SAMLSSO_SP_MODE === 'true';
    }
  }, {
    key: "setCsrfTokenHeader",
    value: function setCsrfTokenHeader(agent) {
      agent.set(this.csrfTokenHeader, this.csrfToken);
    }

    /**
     * Returns true for SSO unauthorized response error.
     * @param {Object} error error object which is indicative of an error
     * during the request
     * @param {boolean} ssoAuth flag to indicate if SSO authentication is performed.
     */
  }, {
    key: "getErrorResponse",
    value: function getErrorResponse(response, error, ssoAuth) {
      var responseObj;
      // Handle SP initiated SSO.
      if (this.isSSOUnauthorizedError(error, ssoAuth)) {
        responseObj = response;
      } else {
        responseObj = response ? response.body || response.error : error;
        if (responseObj && response) {
          responseObj.response = _Object$assign({}, response, {
            body: null
          });
        }
        // for a POST response 'errors' array object returned rather than Error object
        // therefore handling the status to ensure it's not lost -- BOSs
        if (this.isPostResponseError(responseObj)) {
          responseObj.status = response ? response.status : error.status;
        }
      }
      responseObj.header = response && response.header;
      return responseObj;
    }

    /**
     * Checks the response returned from a REST call. Called from each of the
     * functions within this class.
     * @param {Object} error error object which is indicative of an error
     * during the request
     * @param {Object} endpointResponse Response object of the REST endpoint being called,
     * from which the body and header are taken and passed to the callback.
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details.
     * @param {boolean} ssoAuth flag to indicate if SSO authentication is performed.
     *
     */
  }, {
    key: "invokeCallbackWithResponse",
    value: function invokeCallbackWithResponse(error, endpointResponse, callback) {
      var ssoAuth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!callback || typeof callback !== 'function') {
        throw new Error('The callback argument must be of type function');
      }
      // Check if there was an error response from CSRF token call. If so store it, as the API calls
      // are dependant on it, so they should fail and this error should bubble up to the error
      // boundary in UI.
      var response = this.csrfTokenErrorResponse ? this.csrfTokenErrorResponse.response : endpointResponse;
      if (error || !response.ok) {
        var responseObj = this.getErrorResponse(response, error, ssoAuth);
        callback(false, responseObj);
      } else {
        var responseData = ssoAuth ? response : response.body;
        if (responseData && response) {
          responseData.response = _Object$assign({}, response, {
            body: null
          });
        }
        callback(true, responseData, response.header);
      }
    }

    /**
     * Function called to check authorization. Called from each of the
     * functions within this class.
     */
  }, {
    key: "unauthorizedRedirect",
    value: function unauthorizedRedirect(request) {
      var _context;
      var url = _concatInstanceProperty(_context = "".concat(process.env.PUBLIC_URL)).call(_context, process.env.REACT_APP_UNAUTHORIZED_REDIRECT_URL || '/login');
      request.on('response', function (response) {
        if (response.unauthorized) {
          sessionStorage.removeItem('username');
          if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
            /* istanbul ignore next */
            window.history.pushState({
              redirectedFrom: {
                pathname: window.location.pathname
              }
            }, null, url);
          }
        }
      });
    }

    /**
     * GET call to a REST API and optionally pass parameters to the query.
     * @param {string} url address of the REST service to call
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details.
     * @param {Object} [params={}] - parameters to the query
     * @param {boolean} ssoAuth flag to indicate if SSO authentication is performed.
     * @param {Object} headers custom headers when making POST requests.
     * @param {Object} options object containing additional options: responseType (String)
     *
     */
  }, {
    key: "get",
    value: function get(url, callback) {
      var _this = this;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var ssoAuth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var getData = function getData() {
        var agent = superagent.get(url).set(acceptLanguage, _this.getUserSelectedLanguage());
        _this.setHeaders(agent, headers, url);
        if (options.responseType) {
          agent.responseType(options.responseType);
        }
        agent.timeout({
          response: _this.getRestResponseTimeout(),
          deadline: _this.getRestDeadlineTimeout()
        }).query(params).withCredentials().use(_this.unauthorizedRedirect).end(function (error, response) {
          _this.invokeCallbackWithResponse(error, response, callback, ssoAuth);
        });
      };
      var callbackAfterRestCall = this.executeRestAPICall.bind(this, getData);
      this.checkCSRFToken(callbackAfterRestCall, url, ssoAuth);
    }

    /**
     * Applies the given headers to the agent. Also sets the CSRF token header if one is defined.
     * @param {Object} agent agent object
     * @param {Object} headers headers to set
     * @param {string} url the request URL which will have headers added for
     */
  }, {
    key: "getWithoutCredentials",
    value:
    /**
     * GET call to a REST API, without Credentials
     *
     * @param {string} url address of the REST service to call
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details.
     */
    function getWithoutCredentials(url, callback) {
      var agent = superagent.get(url).set(acceptLanguage, this.getUserSelectedLanguage());
      agent.then(function (response) {
        callback(true, response);
      }).catch(function (error) {
        return callback(false, error);
      });
    }

    /**
     * POST call to a REST API.
     *
     * @param {string} url address of the REST service to call
     * @param {Object} data content to be passed to the POST call
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details
     * @param {('form'|'json')} [type='json'] whether it is 'application/x-www-form-urlencoded' or
     * 'application/json' data being sent
     * @param {boolean} ssoAuth flag to indicate if SSO authentication is performed.
     * @param {Object} headers custom headers when making POST requests.
     */
  }, {
    key: "post",
    value: function post(url, data, callback) {
      var _this2 = this;
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'json';
      var ssoAuth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var headers = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var postData = function postData() {
        var agent = superagent.post(url).type(type).set(acceptLanguage, _this2.getUserSelectedLanguage());
        _this2.setHeaders(agent, headers, url);
        agent.timeout({
          response: _this2.getRestResponseTimeout(),
          deadline: _this2.getRestDeadlineTimeout()
        }).send(data).withCredentials().use(_this2.unauthorizedRedirect).end(function (error, response) {
          _this2.invokeCallbackWithResponse(error, response, callback, ssoAuth);
        });
      };
      var callbackAfterRestCall = this.executeRestAPICall.bind(this, postData);
      this.checkCSRFToken(callbackAfterRestCall, url, ssoAuth);
    }

    /**
     * DELETE call to a REST API.
     *
     * @param {string} url address of the REST service to call
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details
     * @param {Object} headers custom headers when making POST requests.
     */
  }, {
    key: "del",
    value: function del(url, callback) {
      var _this3 = this;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var deleteData = function deleteData() {
        var agent = superagent.del(url).type('json').set(acceptLanguage, _this3.getUserSelectedLanguage());
        _this3.setHeaders(agent, headers, url);
        agent.set('Accept', 'application/json').query(params).withCredentials().use(_this3.unauthorizedRedirect).end(function (error, response) {
          _this3.invokeCallbackWithResponse(error, response, callback);
        });
      };
      var callbackAfterRestCall = this.executeRestAPICall.bind(this, deleteData);
      this.checkCSRFToken(callbackAfterRestCall, url);
    }

    /**
     * Executes the REST API call function that is specified. A timeout
     * will be set if one is specified in the development environment settings.
     *
     * @param {requestCallback} callback function which should be called upon completion
      */
  }, {
    key: "executeRestAPICall",
    value: function executeRestAPICall(callback) {
      var restRespDelay = process.env.REACT_APP_DELAY_REST_API * 1000;
      if (restRespDelay) {
        /* istanbul ignore next */
        window.setTimeout(function () {
          callback();
        }, restRespDelay);
      } else {
        callback();
      }
    }

    /**
     * Utility to parseJSON and construct a Model object with it.
       * @param {any} json JSON data passed in
     * @param {Object} OfType Model object whose constructor will be called with the JSON data.
     *
     * @returns {Object} constructed Model object if the json has data otherwise an empty array
     */
  }, {
    key: "parseJson",
    value: function parseJson(json, OfType) {
      var _context2;
      if (!json.data) {
        return [];
      }
      return _mapInstanceProperty(_context2 = json.data).call(_context2, function (object) {
        return new OfType(object);
      });
    }

    /**
     * Utility to parseResourceJSON Resource and construct a Model object with it.
      * @param {any} json JSON data passed in
     * @param {Object} OfType Model object whose constructor will be called with the JSON data.
     * @returns {Object} constructed Model object if the json has data otherwise an empty array
      */
  }, {
    key: "parseResourceJson",
    value: function parseResourceJson(json, OfType) {
      var _context3;
      if (!json.resource) {
        return [];
      }
      if (!json.resource.data) {
        return [];
      }
      return _mapInstanceProperty(_context3 = json.resource.data).call(_context3, function (object) {
        return new OfType(object);
      });
    }

    /**
     * Executes the REST API call function that is specified.
     *
     * @param {string} url address of the REST service to call
     * @param {requestCallback} callback function which is called when the request has
     * been completed. See 'requestCallback' for more details
     * @returns {blob} constructed blob object if the json has data otherwise an empty array
     */
  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, callback) {
        var _this4 = this;
        var downloadCallback;
        return _regeneratorRuntime.wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              downloadCallback = function downloadCallback() {
                var initAgent = function initAgent() {
                  if (_this4.csrfToken) {
                    return superagent.get(url).set(_this4.csrfTokenHeader, _this4.csrfToken);
                  }
                  return superagent.get(url);
                };
                return initAgent().set(acceptLanguage, _this4.getUserSelectedLanguage()).responseType('blob').withCredentials().then(function (response) {
                  var cd = response.headers['content-disposition'] || '';
                  var fn = cd.match(/filename="(.*)"/);
                  var filename = fn ? fn[1] : null;
                  return {
                    filename: filename,
                    blob: response.body
                  };
                }).then(function (_ref) {
                  var filename = _ref.filename,
                    blob = _ref.blob;
                  return callback(filename, new Blob([blob], {
                    type: 'application/octet-stream'
                  }));
                });
              }; // check if CSRF needed or not on the call and if so fetch CSRF token
              this.checkCSRFToken(downloadCallback, url);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee, this);
      }));
      function downloadFile(_x, _x2) {
        return _downloadFile.apply(this, arguments);
      }
      return downloadFile;
    }()
    /**
     * Gets the current user's selectedLanguage.
     * It first queries localStorage and if not found falls back on English.
     * @returns {string} locale code for the current users language
     */
  }, {
    key: "getUserSelectedLanguage",
    value: function getUserSelectedLanguage() {
      var userLanguage = localStorage.getItem('selectedLanguage');
      if (userLanguage === undefined || userLanguage === null) {
        userLanguage = 'en';
      }
      return userLanguage;
    }

    /**
     * Handles an API failure and throws an appropriate error.
     * In most instances an array of error objects are passed in as an input and
     * handled appropriately. The errors thrown here are handled by the
     * ErrorBoundaryComponent to display error messages based on the error data
     * code or status.
     *
     * @param {Object} errorData The list of action types.
     */
  }, {
    key: "handleAPIFailure",
    value: function handleAPIFailure(errorData) {
      if (errorData) {
        var errors = errorData.errors,
          status = errorData.status;
        if (errors && errors.length > 0) {
          // eslint-disable-next-line camelcase
          var _errors$ = errors[0],
            message = _errors$.message,
            code = _errors$.code,
            message_id = _errors$.message_id;
          var error = new Error(message);
          error.status = status || code || null;
          // eslint-disable-next-line camelcase
          error.messageId = message_id;
          throw error;
        }
        throw errorData;
      }
    }
  }]);
  return RESTService;
}();
_defineProperty(RESTService, "csrfTokenHeader", 'X-IBM-SPM-CSRF');
_defineProperty(RESTService, "csrfToken", undefined);
_defineProperty(RESTService, "csrfTokenErrorResponse", undefined);
_defineProperty(RESTService, "isFetchingCSRFToken", false);
_defineProperty(RESTService, "pausedRequests", []);
_defineProperty(RESTService, "apiEndPointsFunction", null);
_defineProperty(RESTService, "registerApiEndPointsFunction", function (apiEndPoints) {
  RESTService.apiEndPointsFunction = apiEndPoints;
  if (typeof RESTService.apiEndPointsFunction !== 'function') throw new Error('The function registerApiEndPointsFunction must have an argument of type function');
});
_defineProperty(RESTService, "getReactAppRestURL", function (resource) {
  var _context5;
  if (RESTService.apiEndPointsFunction) {
    return RESTService.apiEndPointsFunction(resource);
  }
  return _concatInstanceProperty(_context5 = "".concat(process.env.REACT_APP_REST_URL, "/")).call(_context5, resource);
});
_defineProperty(RESTService, "isSSOUnauthorizedError", function (error, ssoAuth) {
  var spSSOEnabled = RESTService.isSPSSOEnabled();
  return ssoAuth && spSSOEnabled && (error === null || error === void 0 ? void 0 : error.status) === 401;
});
_defineProperty(RESTService, "isPostResponseError", function (responseObj) {
  var spSSOEnabled = RESTService.isSPSSOEnabled();
  return !responseObj.status && !spSSOEnabled || spSSOEnabled && window.location.pathname !== '/' && window.location.pathname !== '/login';
});
_defineProperty(RESTService, "setHeaders", function (agent, headers, url) {
  _Object$keys(headers).forEach(function (key) {
    return agent.set(key, headers[key]);
  });
  // only set the IBM SPM CSRF token on API requests to SPM Rest APIs endpoints
  // however we do need to set it on URLs that could redirect us to a SPM Rest API, like SSO ACS
  if (RESTService.csrfToken && (_startsWithInstanceProperty(url).call(url, EnvUtils.getEnvironmentProperty('REACT_APP_REST_URL', '')) || url === EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_SP_ACS_URL', ''))) {
    RESTService.setCsrfTokenHeader(agent);
  }
});
/**
 * Checks if the given URL is whitelisted or not. Whitelisted URL suffixes are defined in the
 * REACT_APP_CSRF_ALLOWLIST environment variable.
 */
_defineProperty(RESTService, "isWhiteListedCsrfUrl", function () {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var whitelistedUrls = EnvUtils.getEnvironmentProperty('REACT_APP_CSRF_ALLOWLIST', '').split(',');
  return whitelistedUrls.some(function (whiteListedUrl) {
    return whiteListedUrl.length > 0 && _endsWithInstanceProperty(url).call(url, whiteListedUrl);
  });
});
/**
 * Pauses the current request to check if CSRF protection is enabled, if so and we are missing the
 * token it requests a new token from the server before continuing with the request. Any requests
 * that come in while we are fetching the CSRF token will be queued and executed once the CSRF
 * token is received. Certain URLs are whitelisted and no token will be requested for them.
 * @param {function} request current request
 * @param {string} url url of the current request, used to check if the request is whitelisted
 */
_defineProperty(RESTService, "checkCSRFToken", function (request, url) {
  var isSsoAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isWhiteListedCsrfUrl = RESTService.isWhiteListedCsrfUrl(url);
  var isIDPSSOLoginURL = EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_IDP_LOGININITIAL_URL', '') === url;
  if (EnvUtils.getEnvironmentProperty('REACT_APP_REQUIRE_CSRF_TOKEN') !== true || RESTService.csrfToken || isWhiteListedCsrfUrl || isIDPSSOLoginURL || isSsoAuth) {
    // If we already have a token or CSRF protection is disabled then execute the request
    request();
  } else {
    // Queue the original request
    RESTService.pausedRequests.push(request);
    // Fetch a token if we are not already fetching one
    if (!RESTService.isFetchingCSRFToken) {
      RESTService.isFetchingCSRFToken = true;
      // Execute any queued requests once we have the token
      RESTService.fetchCSRFToken(RESTService.loopThroughQueue);
    }
  }
});
/**
 * Loop through the requests.
 * @param {Object} errorResponse HTTP response with error if there was  a problem generating token
 * @param {boolean} tokenWasGenerated Indicates if a token was  generated by the call to API
 */
_defineProperty(RESTService, "loopThroughQueue", function (tokenWasGenerated, errorResponse) {
  // if there was an error response store it.
  if (!tokenWasGenerated) {
    RESTService.csrfTokenErrorResponse = errorResponse;
  }
  while (RESTService.pausedRequests.length > 0) {
    var pausedRequest = RESTService.pausedRequests.pop();
    pausedRequest();
  }
});
/**
 * Fetch a new CSRF token from server.
 *
 * @param {Object} params parameters to the query
 * @param {boolean} ssoAuth flag to indicate if SSO authentication is performed.
 * @param {Object} headers custom headers when making POST requests.
 * @param {Object} callback callback to execute when this function finishes
 */
_defineProperty(RESTService, "fetchCSRFToken", function (callback) {
  var _context6;
  //  just pulling url out to facilitate test ofm it
  var url = _concatInstanceProperty(_context6 = "".concat(EnvUtils.getEnvironmentProperty('REACT_APP_REST_URL'), "/")).call(_context6, RESOURCE_NAMES.csrfTokens);
  var getData = function getData() {
    var agent = superagent.get(url).set(acceptLanguage, RESTService.getUserSelectedLanguage());
    agent.timeout({
      response: RESTService.getRestResponseTimeout(),
      deadline: RESTService.getRestDeadlineTimeout()
    }).withCredentials().use(RESTService.unauthorizedRedirect).end(function (error, response) {
      // Extract CSRF token from response header
      RESTService.csrfToken = response === null || response === void 0 ? void 0 : response.header[RESTService.csrfTokenHeader.toLowerCase()];
      RESTService.isFetchingCSRFToken = false;
      RESTService.invokeCallbackWithResponse(error, response, callback);
    });
  };
  RESTService.executeRestAPICall(getData);
});
export { RESTService as default };